<div style="padding:30px">
    <ul class="nav nav-tabs" style="margin: 10px;">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item" (click)="choose(item.id)">
            <span  style="cursor: pointer;" [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <!-- 營運分析 tab:運營面(DuckDB 確定性數字直出圖表)+ 個別用戶面(LLM 名單 + 大戶動能儀錶板) -->
    <div *ngIf="now=='9'" style="margin:10px;">
        <!-- 切進本 tab 時 choose('9') 會自動 loadAnalysis,毋需手動重新整理按鈕 -->
        <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin:6px 0 12px;">
            <div style="display:inline-flex;border:1px solid #c7ccd9;border-radius:20px;overflow:hidden;background:#fff;">
                <button type="button" (click)="analysis_view='platform'" style="border:0;padding:7px 20px;cursor:pointer;outline:none;"
                        [style.background]="analysis_view=='platform' ? '#2f6fed' : 'transparent'"
                        [style.color]="analysis_view=='platform' ? '#fff' : '#5b6270'">
                    <i class="fas fa-chart-line" style="margin-right:6px;"></i>運營面
                </button>
                <button type="button" (click)="analysis_view='users'" style="border:0;padding:7px 20px;cursor:pointer;outline:none;"
                        [style.background]="analysis_view=='users' ? '#2f6fed' : 'transparent'"
                        [style.color]="analysis_view=='users' ? '#fff' : '#5b6270'">
                    <i class="fas fa-user-friends" style="margin-right:6px;"></i>個別用戶面
                </button>
            </div>
            <span *ngIf="analysis_loading"><i class="fas fa-spinner fa-spin"></i>&nbsp;載入中…</span>
        </div>
        <div *ngIf="!analysis_loading && analysis_reports.length==0" class="tips">
            尚無分析報告。請用 DB_tool 桌面工具產生分析並上傳。
        </div>
        <div *ngFor="let r of analysis_reports" class="card mb-3"
             style="margin-bottom:18px;box-shadow:0 1px 4px rgba(0,0,0,0.08);border-radius:8px;overflow:hidden;">
            <div class="card-header" style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:6px;">
                <div>
                    <span class="badge badge-info">{{typeLabel(r.report_type)}}</span>
                    <b>&nbsp;#{{r.id}}</b> · {{r.period_start}} ~ {{r.period_end}}
                </div>
                <span class="tips">{{r.generated_at}} · {{r.model}}</span>
            </div>
            <div class="card-body">

                <!-- ═══════════════ 運營面:平台健康度 ═══════════════ -->
                <div *ngIf="analysis_view=='platform'">
                    <div *ngIf="r.headline" style="background:#eef4fd;border-left:4px solid #2f6fed;border-radius:4px;padding:12px 16px;margin-bottom:16px;font-size:15px;line-height:1.7;">
                        <i class="fas fa-bullhorn" style="margin-right:8px;color:#2f6fed;"></i><b>{{r.headline}}</b>
                    </div>
                    <div *ngIf="!r.ph" class="tips" style="padding:20px 0;">
                        此報告尚無「平台健康度」數據(由舊版工具產生)。用新版 DB_tool 重新產生並上傳後,這裡會顯示註冊/活躍/營收/付費趨勢、D1~D30 留存與收益分析。
                    </div>
                    <ng-container *ngIf="r.ph">
                        <h6 style="font-weight:700;margin:4px 0 10px;">總體概覽</h6>
                        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(400px,1fr));gap:12px;margin-bottom:18px;">
                            <div *ngIf="r.regChartM" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 4px;">註冊數趨勢 — 男</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.regChartM" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                            <div *ngIf="r.regChartF" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 4px;">註冊數趨勢 — 女</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.regChartF" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                            <div *ngIf="r.activeChartM" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 4px;">活躍用戶趨勢 — 男(每日登入)</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.activeChartM" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                            <div *ngIf="r.activeChartF" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 4px;">活躍用戶趨勢 — 女(每日登入)</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.activeChartF" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                            <div *ngIf="r.revenueChart" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 4px;">營收趨勢(儲值 / 提領)</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.revenueChart" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                            <div *ngIf="r.payersChart" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 4px;">付費人口趨勢(人數 / 次數)</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.payersChart" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                        </div>

                        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(175px,1fr));gap:10px;margin-bottom:18px;">
                            <div *ngIf="r.payRates" class="card" style="padding:12px;margin:0;text-align:center;">
                                <div style="font-size:24px;font-weight:700;color:#2f6fed;">{{r.payRates.first_pay_rate_pct}}%</div>
                                <div class="tips">首次付費率(這段期間註冊的男性 {{r.payRates.male_cohort | number}} 人)</div>
                            </div>
                            <div *ngIf="r.payRates" class="card" style="padding:12px;margin:0;text-align:center;">
                                <div style="font-size:24px;font-weight:700;color:#2f6fed;">{{r.payRates.second_pay_rate_pct}}%</div>
                                <div class="tips">二次付費率(付過 2 次以上)</div>
                            </div>
                            <div *ngIf="r.perPayer" class="card" style="padding:12px;margin:0;text-align:center;">
                                <div style="font-size:24px;font-weight:700;color:#b8860b;">{{r.perPayer.avg_daily_payers | number}}</div>
                                <div class="tips">日均付費人數</div>
                            </div>
                            <div *ngIf="r.perPayer" class="card" style="padding:12px;margin:0;text-align:center;">
                                <div style="font-size:24px;font-weight:700;color:#b8860b;">{{r.perPayer.txns_per_payer_day}}</div>
                                <div class="tips">每付費戶日均付費次數</div>
                            </div>
                            <div *ngIf="r.perPayer" class="card" style="padding:12px;margin:0;text-align:center;">
                                <div style="font-size:24px;font-weight:700;color:#2f9e58;">{{r.perPayer.twd_per_payer_day | number}}</div>
                                <div class="tips">每付費戶日均消費額(元)</div>
                            </div>
                            <div *ngIf="r.payerPop" class="card" style="padding:12px;margin:0;text-align:center;">
                                <div style="font-size:24px;font-weight:700;" [style.color]="r.payerPop.delta_pct >= 0 ? '#2f9e58' : '#c0392b'">
                                    {{r.payerPop.delta_pct > 0 ? '+' : ''}}{{r.payerPop.delta_pct}}%
                                </div>
                                <div class="tips">付費人口增減(前半 {{r.payerPop.first_half_payers | number}} → 後半 {{r.payerPop.second_half_payers | number}} 人)</div>
                            </div>
                        </div>

                        <h6 style="font-weight:700;margin:4px 0 6px;">用戶留存 ① 註冊後 N 天內(累計曾發生)
                            <span class="tips" style="font-weight:400;">D3 = 註冊後 3 天內有任一天發生過;分母僅含已滿 N 天觀察期者</span>
                        </h6>
                        <div class="tips" style="margin:0 0 6px;">
                            怎麼讀:N 越大、能算的人越少(例如 8/1 註冊的人,「14 天內」已有答案可算進 D14,
                            但他的第 20~30 天還沒發生,不能算進 D30),所以樣本數一路遞減是正常的。
                            也因為每一列的分母是「不同一批人」(越往下只剩越早註冊者),
                            百分比偶爾比上一列低,代表較早註冊那批的表現較差,不是資料錯誤;
                            固定同一批人看,累計數字只會增加不會減少。<br>
                            <b>登入欄接近 100% 是正常的</b>:註冊當天必然登入,所以「N 天內曾登入」幾乎人人達成——
                            要看真正的回訪率請看下面第 ② 表(當日口徑)。<br>
                            <b>男女登入不可直接比高低</b>:男性有登入旗標可用(對官方登入誤差 0.11%),
                            女性系統沒有這個欄位、只能用行為紀錄推估,新註冊當週會被明顯低估——女性請看「趨勢變化」而非與男性比絕對值。
                        </div>
                        <table class="table table-sm" style="margin-bottom:12px;" *ngIf="r.retentionRows?.length">
                            <thead><tr>
                                <th>天數</th><th style="text-align:right;">有登入 %(男)</th><th style="text-align:right;">有登入 %(女)</th>
                                <th style="text-align:right;">有花費 %(男)</th><th style="text-align:right;">有儲值 %(男)</th>
                                <th style="text-align:right;">男-對話 %</th><th style="text-align:right;">男-通話 %</th>
                                <th style="text-align:right;">女-對話 %</th><th style="text-align:right;">女-通話 %</th>
                                <th style="text-align:right;">樣本數(男 / 女)</th>
                            </tr></thead>
                            <tbody>
                                <tr *ngFor="let row of r.retentionRows">
                                    <td><b>D{{row.n}} 內</b></td>
                                    <td style="text-align:right;">{{row.m_login != null ? row.m_login + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.f_login != null ? row.f_login + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.spend_pct != null ? row.spend_pct + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.pay_pct != null ? row.pay_pct + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.m_chat != null ? row.m_chat + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.m_call != null ? row.m_call + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.f_chat != null ? row.f_chat + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.f_call != null ? row.f_call + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.eligible != null ? (row.eligible | number) : '-'}} / {{row.f_eligible != null ? (row.f_eligible | number) : '-'}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <h6 style="font-weight:700;margin:4px 0 6px;">用戶留存 ② 註冊後第 N 天(當日)— 這張才是一般說的「留存」
                            <span class="tips" style="font-weight:400;">只看那一天:第 1 天 = 註冊當天、第 2 天 = 隔天(等同業界說的 D1 留存)、第 7 天 = 註冊後第 7 天。和上表對照可看出「N 天內做過」與「到第 N 天還在做」的差異(第 1 天兩表相同)</span>
                        </h6>
                        <table class="table table-sm" style="margin-bottom:6px;" *ngIf="r.retentionRowsDay?.length">
                            <thead><tr>
                                <th>天數</th><th style="text-align:right;">有登入 %(男)</th><th style="text-align:right;">有登入 %(女)</th>
                                <th style="text-align:right;">有花費 %(男)</th><th style="text-align:right;">有儲值 %(男)</th>
                                <th style="text-align:right;">男-對話 %</th><th style="text-align:right;">男-通話 %</th>
                                <th style="text-align:right;">女-對話 %</th><th style="text-align:right;">女-通話 %</th>
                                <th style="text-align:right;">樣本數(男 / 女)</th>
                            </tr></thead>
                            <tbody>
                                <tr *ngFor="let row of r.retentionRowsDay">
                                    <td><b>第 {{row.n}} 天</b></td>
                                    <td style="text-align:right;">{{row.m_login != null ? row.m_login + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.f_login != null ? row.f_login + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.spend_pct != null ? row.spend_pct + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.pay_pct != null ? row.pay_pct + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.m_chat != null ? row.m_chat + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.m_call != null ? row.m_call + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.f_chat != null ? row.f_chat + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.f_call != null ? row.f_call + '%' : '-'}}</td>
                                    <td style="text-align:right;">{{row.eligible != null ? (row.eligible | number) : '-'}} / {{row.f_eligible != null ? (row.f_eligible | number) : '-'}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="tips" style="margin-bottom:16px;" *ngIf="r.engMale || r.engFemale">
                            互動平均值(這段期間):
                            <span *ngIf="r.engMale">男性 平均發出 {{r.engMale.avg_msgs_per_active_day}} 則<ng-container *ngIf="r.engMale.avg_msgs_received_per_active_day != null">、收到 {{r.engMale.avg_msgs_received_per_active_day}} 則</ng-container>訊息/活躍日,有通話者平均 {{r.engMale.avg_call_min_per_caller_day}} 分鐘/日;</span>
                            <span *ngIf="r.engFemale">女性 平均發出 {{r.engFemale.avg_msgs_per_active_day}} 則<ng-container *ngIf="r.engFemale.avg_msgs_received_per_active_day != null">、收到 {{r.engFemale.avg_msgs_received_per_active_day}} 則</ng-container>訊息/活躍日,有通話者平均 {{r.engFemale.avg_call_min_per_caller_day}} 分鐘/日。</span>
                            平均對話人數需 chat_record 做對象去重,目前日彙總表無此欄位(資料缺口)。
                        </div>

                        <div *ngIf="r.cohortM || r.cohortF" style="margin-bottom:16px;">
                            <h6 style="font-weight:700;margin:4px 0 6px;">世代分群(cohort)
                                <span class="tips" style="font-weight:400;">每一列是「同一週註冊的一批人」,往右看他們註冊後第 0、1、2…週仍有登入的比例。顏色越深代表留存越好。
                                    越新的世代觀察期越短,所以右邊會呈三角形:已經全部過完的是定案值,過半但還沒全滿的標「約」(暫定),連一半都還沒過完的留空白。
                                    <b>第 0 週接近 100% 是正常的</b>(他們就是那一週註冊的);真正要看的是第 1 週之後的落點與衰減速度。
                                    女性因系統無登入旗標、以行為推估,註冊當週會被低估,請看同性別的世代間變化,不要與男性比絕對值。</span>
                            </h6>
                            <ng-container *ngFor="let cg of [{g: r.cohortM, label: '男性'}, {g: r.cohortF, label: '女性'}]">
                                <div *ngIf="cg.g" style="margin-bottom:10px;overflow-x:auto;">
                                    <div style="font-weight:600;margin-bottom:2px;">{{cg.label}}</div>
                                    <table class="table table-sm" style="margin:0;width:auto;">
                                        <thead><tr>
                                            <th>註冊週</th><th style="text-align:right;">人數</th>
                                            <th *ngFor="let w of cg.g.weeks" style="text-align:right;min-width:64px;">第{{w}}週</th>
                                        </tr></thead>
                                        <tbody>
                                            <tr *ngFor="let row of cg.g.rows">
                                                <td>{{row.cohort}}<span *ngIf="row.mixed" style="color:#c0392b;" title="同列已定案的格子分母不一致,數字不可橫向比較">&nbsp;⚠</span><span
                                                        *ngIf="row.partialWeek" style="color:#b8860b;"
                                                        [title]="'這一列是半週:報表期間從 ' + r.period_start + ' 起算,只含 ' + row.regFrom + '~' + row.regTo + ' 註冊的人(' + row.regDays + ' 天,不是完整 7 天)。人數不可與其他列比,留存比例仍可看。'">&nbsp;半週</span></td>
                                                <td style="text-align:right;" [title]="row.regFrom ? ('註冊日 ' + row.regFrom + '~' + row.regTo + '(' + row.regDays + ' 天)') : ''">{{row.size | number}}</td>
                                                <td *ngFor="let w of cg.g.weeks" style="text-align:right;font-variant-numeric:tabular-nums;"
                                                    [class.text-muted]="row.cells[w] == null"
                                                    [style.font-style]="row.prov[w] ? 'italic' : null"
                                                    [style.color]="row.prov[w] ? '#7a6000' : null"
                                                    [title]="row.cells[w] == null
                                                        ? ('還算不出來:連一半的人都還沒過完第' + w + '週。這一批最晚 ' + row.lastReg + ' 註冊,他的第' + w + '週要到 ' + row.ready[w] + ' 才過完。')
                                                        : (row.prov[w]
                                                            ? ('暫定值。這一批 ' + (row.size | number) + ' 人裡,目前只有 ' + (row.els[w] | number) + ' 人過完第' + w + '週,先用這些人算。等資料到 ' + row.ready[w] + ' 全部過完後會定案。此格一個人 = ' + row.ppPerPerson[w] + ' 個百分點,還沒過完的 ' + (row.size - row.els[w] | number) + ' 人最多可能讓數字移動 ' + row.maxShift[w] + ' 個百分點。')
                                                            : ('已定案。分母 ' + (row.els[w] | number) + ' 人（整批都過完了）。一個人 = ' + row.ppPerPerson[w] + ' 個百分點。'))"
                                                    [style.background]="row.cells[w] != null ? 'rgba(47,111,237,' + (0.06 + row.cells[w] / 140) + ')' : 'transparent'">
                                                    {{row.cells[w] != null ? (row.prov[w] ? '約' : '') + row.cells[w] + '%' : '—'}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="tips" style="margin-top:2px;">
                                        <b>「約」開頭的斜體</b>是暫定值:這一批還沒全部過完那一週,先用已經過完的人算<span *ngIf="cg.g.nextFill">,資料到 <b>{{cg.g.nextFill}}</b> 之後那條斜線會一起定案</span>。
                                        暫定值只在「過半且至少 100 人」時才顯示;樣本更小的一律留空白,因為分母幾十人時一個人就影響好幾個百分點。
                                        <b>「—」</b>是還算不出來<span *ngIf="r.dataThrough">(目前資料到 {{r.dataThrough}})</span>。
                                        滑到任一格可看該格的分母、到期日、一個人等於幾個百分點,以及暫定值最多還會移動多少。
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(400px,1fr));gap:12px;margin-bottom:12px;">
                            <div *ngIf="r.ltvChart" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 0;">LTV 曲線(男性)<span class="tips" style="font-weight:400;" *ngIf="r.ltvCohortSize">&nbsp;固定世代 {{r.ltvCohortSize | number}} 人 / 涵蓋 {{r.ltvRegDays}} 個註冊日</span></div>
                                <div class="tips" style="padding:0 4px 4px;">只取「已滿 30 天觀察期」的同一批男性(第 1 天 = 註冊當天),看他們註冊後第 N 天的人均累計儲值。
                                    固定同一批人才能保證曲線只升不降、且可跨期比較;曲線越晚變平,代表用戶付費得越久。</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.ltvChart" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                            <div *ngIf="r.arpdauChart" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 0;">ARPDAU(每日)</div>
                                <div class="tips" style="padding:0 4px 4px;">當天儲值總額 ÷ 當天登入人數(皆為平台官方日結數字,未做身分過濾)= 平均每位登入用戶帶來幾元;衡量流量的「變現效率」。
                                    <b>分母是官方登入人數,約為本頁「有登入」人數的 7 成</b>,兩者不可互換——拿 ARPDAU × MAU 回推營收會高估約 2 倍。</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.arpdauChart" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                            <div *ngIf="r.mauChartM" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 0;">MAU 趨勢 — 男</div>
                                <div class="tips" style="padding:0 4px 4px;">每一天往回看 30 天,有活動過的不重複人數(滾動 30 天活躍;活動口徑略高於真實登入)。</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.mauChartM" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                            <div *ngIf="r.mauChartF" class="card" style="padding:10px;margin:0;">
                                <div style="font-weight:600;padding:0 4px 0;">MAU 趨勢 — 女</div>
                                <div class="tips" style="padding:0 4px 4px;">每一天往回看 30 天,有活動過的不重複人數(滾動 30 天活躍;活動口徑略高於真實登入)。</div>
                                <highcharts-chart [Highcharts]="Highcharts" [options]="r.mauChartF" style="display:block;width:100%;"></highcharts-chart>
                            </div>
                        </div>

                        <div *ngIf="r.payRateChart" class="card" style="padding:10px;margin:0 0 12px;">
                            <div style="font-weight:600;padding:0 4px 0;">首充率 / 次充率(依註冊週)</div>
                            <div class="tips" style="padding:0 4px 4px;">每一點是「該週新註冊的男性」中,後來曾儲值 1 次以上 / 2 次以上的比例。最新一兩週的人還沒經過完整的付費觀察期,數字會偏低,別當成下滑。</div>
                            <highcharts-chart [Highcharts]="Highcharts" [options]="r.payRateChart" style="display:block;width:100%;"></highcharts-chart>
                        </div>

                        <div *ngIf="r.topshareChart" class="card" style="padding:10px;margin:0 0 8px;">
                            <div style="font-weight:600;padding:0 4px 4px;">收益集中度:前 1% / 5% / 10% 付費戶占總儲值額(週)</div>
                            <highcharts-chart [Highcharts]="Highcharts" [options]="r.topshareChart" style="display:block;width:100%;"></highcharts-chart>
                        </div>

                        <details *ngIf="r.notes?.length" style="margin-top:6px;">
                            <summary style="cursor:pointer;" class="tips">資料口徑與稽核備註({{r.notes.length}} 條)—— 若有圖表沒出現,原因會寫在這裡</summary>
                            <ul class="tips" style="margin:6px 0 0;padding-left:18px;line-height:1.8;">
                                <li *ngFor="let n of r.notes">{{n}}</li>
                            </ul>
                        </details>
                    </ng-container>
                </div>

                <!-- ═══════════════ 個別用戶面 ═══════════════ -->
                <div *ngIf="analysis_view=='users'">
                    <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:12px;margin-bottom:16px;">
                        <details *ngIf="r.diffHtml?.length" style="background:#fdf2f0;border-left:4px solid #e2703a;border-radius:4px;padding:10px 14px;">
                            <summary style="cursor:pointer;font-weight:600;color:#c0392b;">
                                <i class="fas fa-exclamation-triangle" style="margin-right:6px;"></i>運營困境
                                <span class="badge badge-pill" style="background:#e2703a;color:#fff;margin-left:6px;">{{r.diffHtml.length}}</span>
                                <span class="tips" style="font-weight:400;margin-left:8px;">點開看全部</span>
                            </summary>
                            <ul style="margin:10px 0 0;padding-left:18px;line-height:1.8;"><li *ngFor="let x of r.diffHtml" style="margin-bottom:6px;" [innerHTML]="x"></li></ul>
                        </details>
                        <details *ngIf="r.imprHtml?.length" style="background:#eef4fd;border-left:4px solid #2f6fed;border-radius:4px;padding:10px 14px;">
                            <summary style="cursor:pointer;font-weight:600;color:#2f6fed;">
                                <i class="fas fa-lightbulb" style="margin-right:6px;"></i>改善方向
                                <span class="badge badge-pill" style="background:#2f6fed;color:#fff;margin-left:6px;">{{r.imprHtml.length}}</span>
                                <span class="tips" style="font-weight:400;margin-left:8px;">點開看全部</span>
                            </summary>
                            <ul style="margin:10px 0 0;padding-left:18px;line-height:1.8;"><li *ngFor="let x of r.imprHtml" style="margin-bottom:6px;" [innerHTML]="x"></li></ul>
                        </details>
                        <details *ngIf="r.follHtml?.length" style="background:#f4f5f7;border-left:4px solid #8a93a6;border-radius:4px;padding:10px 14px;">
                            <summary style="cursor:pointer;font-weight:600;color:#5b6270;">
                                <i class="fas fa-tasks" style="margin-right:6px;"></i>後續追蹤
                                <span class="badge badge-pill" style="background:#8a93a6;color:#fff;margin-left:6px;">{{r.follHtml.length}}</span>
                                <span class="tips" style="font-weight:400;margin-left:8px;">點開看全部</span>
                            </summary>
                            <ul style="margin:10px 0 0;padding-left:18px;line-height:1.8;"><li *ngFor="let x of r.follHtml" style="margin-bottom:6px;" [innerHTML]="x"></li></ul>
                        </details>
                        <details *ngIf="r.recoHtml?.length" style="background:#eefaf1;border-left:4px solid #2f9e58;border-radius:4px;padding:10px 14px;">
                            <summary style="cursor:pointer;font-weight:600;color:#1f7a3f;">
                                <i class="fas fa-thumbs-up" style="margin-right:6px;"></i>建議
                                <span class="badge badge-pill" style="background:#2f9e58;color:#fff;margin-left:6px;">{{r.recoHtml.length}}</span>
                                <span class="tips" style="font-weight:400;margin-left:8px;">點開看全部</span>
                            </summary>
                            <ul style="margin:10px 0 0;padding-left:18px;line-height:1.8;"><li *ngFor="let x of r.recoHtml" style="margin-bottom:6px;" [innerHTML]="x"></li></ul>
                        </details>
                    </div>

                    <div *ngIf="r.whaleGroups?.length" style="margin-bottom:16px;">
                        <h6 style="font-weight:700;margin:4px 0 8px;">大戶動能監控儀錶板
                            <span class="tips" style="font-weight:400;">(依本地精確數字自動分類,非 AI 判讀;期間消費 ≥ 10 萬列入;前後半取「等長兩段」對比(奇數天數捨棄正中間日,避免天數偏差);高成長含「前半零消費、後半大量消費」的回歸大戶;沉睡 = 終身儲值 ≥ 50 萬且這段期間零消費;各類最多列前 12 名)</span>
                        </h6>
                        <div *ngFor="let g of r.whaleGroups" style="margin-bottom:12px;">
                            <div style="font-weight:600;margin-bottom:4px;">
                                <span class="badge" [style.background]="g.color" style="color:#fff;">{{g.label}}</span>
                                <span class="tips" style="margin-left:6px;">{{g.rows.length}} 位</span>
                            </div>
                            <div style="overflow-x:auto;">
                                <table class="table table-sm" style="margin:0;">
                                    <thead><tr>
                                        <th>用戶</th><th style="text-align:right;">期間消費</th><th style="text-align:right;">前半</th>
                                        <th style="text-align:right;">後半</th><th style="text-align:right;">動能</th>
                                        <th style="text-align:right;">活躍天</th><th style="text-align:right;">終身儲值</th>
                                        <th>最後消費</th><th>最後上線</th><th>註冊日</th><th>AI 判讀</th>
                                    </tr></thead>
                                    <tbody>
                                        <ng-container *ngFor="let w of g.rows">
                                            <tr>
                                                <td>
                                                    <a *ngIf="w.uid" href="{{link}}/user/{{w.uid}}" target="_blank">{{displayName(w)}}</a>
                                                    <span *ngIf="!w.uid">{{displayName(w)}}</span>
                                                </td>
                                                <td style="text-align:right;font-variant-numeric:tabular-nums;">{{w.window_spend | number}}</td>
                                                <td style="text-align:right;font-variant-numeric:tabular-nums;">{{w.first_half_spend | number}}</td>
                                                <td style="text-align:right;font-variant-numeric:tabular-nums;">{{w.second_half_spend | number}}</td>
                                                <td style="text-align:right;font-weight:600;" [style.color]="momentumColor(w, r)"
                                                    [title]="w.growth_pct != null ? '後半 ÷ 前半 的成長率' : (w.first_half_spend == 0 && w.second_half_spend > 0 ? '前半沒有消費,成長率算不出百分比;區間內才註冊的是「新進」,區間之前就註冊的才是「回歸」' : '')">
                                                    {{momentumLabel(w, r)}}
                                                </td>
                                                <td style="text-align:right;">{{w.active_days}}</td>
                                                <td style="text-align:right;font-variant-numeric:tabular-nums;">{{w.lifetime_deposit | number}}</td>
                                                <td>{{w.last_active_date || '-'}}</td>
                                                <td>{{w.last_login_date || '-'}}</td>
                                                <td>{{w.register_date || '-'}}</td>
                                                <td>
                                                    <button *ngIf="w.aiFlags?.length" class="btn btn-sm btn-outline-secondary" style="padding:1px 10px;white-space:nowrap;"
                                                            (click)="w.showAi = !w.showAi">
                                                        {{w.showAi ? '收合' : '查看'}}
                                                    </button>
                                                    <span *ngIf="!w.aiFlags?.length" class="tips">-</span>
                                                </td>
                                            </tr>
                                            <tr *ngIf="w.showAi">
                                                <td colspan="11" style="background:#fafbfd;border-left:3px solid #c7ccd9;">
                                                    <div *ngFor="let f of w.aiFlags" style="padding:4px 6px;line-height:1.7;">
                                                        <span class="badge" [style.background]="categoryColor(f.category)" style="color:#fff;">{{categoryLabel(f.category)}}</span>
                                                        <b style="margin:0 6px;font-variant-numeric:tabular-nums;">{{(f.score !== null && f.score !== undefined) ? (f.score | number:'1.0-0') : '-'}}</b>
                                                        {{f.reason}}
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="r.aiOnlyFlags?.length" style="margin-top:8px;">
                        <b>AI 判讀名單(大戶儀錶板未涵蓋者)</b>
                        <div class="tips" style="margin-top:2px;">
                            儀錶板內大戶的 AI 判讀請按各列「查看」;此表只列儀錶板收不到的對象——
                            主要是女性收益用戶,以及消費穩定(沒有被歸進高成長/衰退/新進/沉睡任一類)的男性核心大戶。
                            分數依類別而定,同類別數字才能互相比較:
                            <b>男/女性價值用戶</b> = 這段期間的消費/收益總額(元);
                            <b>花費下滑</b> = 期間後半比前半少了多少(活躍度或消費金額的絕對下降量);
                            <b>沉睡大戶</b> = 歷史累積儲值總額(元,長期未回流的舊金主);
                            <b>快閃流失風險</b> = 期間活躍日均消費(短時間大量消費後迅速沉寂);
                            <b>其他</b> = 依理由欄判讀,無固定定義。
                        </div>
                        <table class="table table-sm" style="margin-top:4px;">
                            <thead><tr><th>用戶</th><th>類別</th><th style="text-align:right;">分數</th><th>理由</th></tr></thead>
                            <tbody>
                                <tr *ngFor="let f of r.aiOnlyFlags">
                                    <td>
                                        <a *ngIf="f.uid" href="{{link}}/user/{{f.uid}}" target="_blank">{{displayName(f)}}</a>
                                        <span *ngIf="!f.uid">{{displayName(f)}}</span>
                                    </td>
                                    <td><span class="badge" [style.background]="categoryColor(f.category)" style="color:#fff;">{{categoryLabel(f.category)}}</span></td>
                                    <td style="text-align:right;font-variant-numeric:tabular-nums;">{{(f.score !== null && f.score !== undefined) ? (f.score | number:'1.0-0') : '-'}}</td>
                                    <td>{{f.reason}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="r.flagsChartOptions" style="margin-top:10px;">
                            <div class="tips" style="margin-bottom:2px;">價值用戶 TOP(這段期間的消費 / 收益總額,元)——其他類別單位不同不併排,動能視覺化見上方大戶儀錶板。</div>
                            <highcharts-chart [Highcharts]="Highcharts" [options]="r.flagsChartOptions" style="display:block;width:100%;"></highcharts-chart>
                        </div>
                    </div>

                    <!-- 預設展開:這裡面有「名單是怎麼挑的」與「這份報告看不到什麼」兩節,
                         正是讀者最常問的「這數字是什麼意思/能不能這樣比」。原本標題寫
                         「完整 summary(原文)」又預設收起,看起來像技術傾印,沒人會點開。 -->
                    <details *ngIf="r.summaryHtml" style="margin-top:12px;" open>
                        <summary style="cursor:pointer;font-weight:600;">完整分析報告
                            <span class="tips" style="font-weight:400;">含「名單是怎麼挑的」與「這份報告看不到什麼」——數字怎麼讀、哪些不能互相比,都寫在裡面</span>
                        </summary>
                        <div style="margin-top:10px;line-height:1.9;max-width:1100px;background:#fafbfd;border:1px solid #eef0f5;border-radius:6px;padding:16px 20px;" [innerHTML]="r.summaryHtml"></div>
                    </details>
                </div>
            </div>
        </div>
    </div>

    <button *ngIf="now=='0'" class="btn btn-primary" (click)="fresh()" style="margin:16px;">更新數據</button>
    <button *ngIf="now=='0'" class="btn btn-outline-primary" (click)="refreshAllRealtimeStats(true)" [disabled]="anyRefreshing" style="margin:16px 0;" title="跳過快取，直接即時計算「上線人數 / 上線未聊天 / 發送訊息(人) / 發送訊息(次)」這 4 項及其拆分">{{ anyRefreshing ? '重算中...' : '上線 / 發訊息 即時重算' }}</button>
    <div *ngIf="info && info.length>0 && !isTab9()" class="tips" style="display:inline">
        {{info[0]['update_dt']}}
    </div>
    <div *ngIf="now=='0'">
        <div *ngFor="let item of info;let i = index" class="card text-white bg-light mb-3 info_item">
            <div class="card-header">{{item.header}}</div>
            <div class="card-body">
                <div (click)="pageobj2.page=0;fuck_view(item.time_id,0)" data-toggle="modal" data-target=".bd-example-modal-lg" class="card-text">儲值金額：<span class="show_it">{{item.deposit_twd_all|number}}</span></div>
            <div>
            <!-- <div class="text-sm ml-2 mb-0">類別：</div> -->
                <div class="text-xs ml-2 mb-0">Android：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_android|number}} ({{item.deposit_twd_android_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">iOS：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_ios|number}} ({{item.deposit_twd_ios_p}}%)</span></div>
                <div *ngIf="((item.deposit_twd_newebpay) - (item.deposit_twd_newebpay_web)) <= 0">
                    <div class="text-xs ml-2 mb-0">藍新：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_newebpay|number}} ({{item.deposit_twd_newebpay_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa">0</span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_newebpay|number}}</span></div>
                </div>
                <div *ngIf="((item.deposit_twd_newebpay) - (item.deposit_twd_newebpay_web)) > 0">
                    <div class="text-xs ml-2 mb-0">藍新：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_newebpay|number}} ({{item.deposit_twd_newebpay_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa">{{(item.deposit_twd_newebpay) - (item.deposit_twd_newebpay_web) | number}}</span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_newebpay_web|number}}</span></div>
                </div>

                <div *ngIf="((item.deposit_twd_ecpay) - (item.deposit_twd_ecpay_web)) <= 0">
                    <div class="text-xs ml-2 mb-0">綠界：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_ecpay|number}} ({{item.deposit_twd_ecpay_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa">0</span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_ecpay|number}}</span></div>
                </div>
                <div *ngIf="((item.deposit_twd_ecpay) - (item.deposit_twd_ecpay_web)) > 0">
                    <div class="text-xs ml-2 mb-0">綠界：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_ecpay|number}} ({{item.deposit_twd_ecpay_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa">{{(item.deposit_twd_ecpay) - (item.deposit_twd_ecpay_web) | number}}</span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_ecpay_web|number}}</span></div>
                </div>

                <div class="text-xs ml-2 mb-0">So-net：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_sonet_small_pay|number}} ({{item.deposit_twd_sonet_small_pay_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">Usdt：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.deposit_twd_usdt|number}} ({{item.deposit_twd_usdt_p}}%)</span></div>



            </div>
            <div (click)="pageobj2.page=0;fuck_view(item.time_id,1)" data-toggle="modal" data-target=".bd-example-modal-lg" class="card-text">提領金額：<span class="show_it">{{item.withdrawal_twd|number}}</span></div>
            <div (click)="gender_type_num = 0; sort_obj_detail = {column:'',sort:'0'}; pageobj2.page=0;fuck_view(item.time_id,2)" data-toggle="modal" data-target=".bd-example-modal-lg" class="card-text">註冊人數：<span class="show_it">{{item.new_user_num_all|number}}</span>
                <div style="margin-left:20px; display: inline-block;margin-bottom:0" class="tips">男生首儲率{{item.deposit_rate}}%</div>
            </div>
            <div>
                <div *ngIf="((item.new_user_num_male) - (item.new_user_num_male_web)) <= 0">
                    <div class="text-xs ml-2 mb-0">男：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_num_male|number}}({{item.new_user_num_male_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa"> 0 </span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_num_male|number}}</span></div>
                </div>

                <div *ngIf="((item.new_user_num_male) - (item.new_user_num_male_web)) > 0">
                    <div class="text-xs ml-2 mb-0">男：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_num_male|number}}({{item.new_user_num_male_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa">{{(item.new_user_num_male - item.new_user_num_male_web)|number}} </span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_num_male_web|number}}</span></div>
                </div>

                <div *ngIf="((item.new_user_num_female) - (item.new_user_num_female_web)) <= 0">
                    <div class="text-xs ml-2 mb-0">女：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_num_female|number}}({{item.new_user_num_female_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa">0</span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_num_female|number}}</span></div>
                </div>

                <div *ngIf="((item.new_user_num_female) - (item.new_user_num_female_web)) > 0">
                    <div class="text-xs ml-2 mb-0">女：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_num_female|number}}({{item.new_user_num_female_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa">{{(item.new_user_num_female - item.new_user_num_female_web)|number}}</span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_num_female_web|number}}</span></div>
                </div>

                <div *ngIf="((item.new_user_unsuccessful_all) - (item.new_user_unsuccessful_all_web)) <= 0">
                    <div class="text-xs ml-2 mb-0">未完成：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_unsuccessful_all|number}}({{item.new_user_unsuccessful_all_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa">0</span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_unsuccessful_all|number}}</span></div>
                </div>

                <div *ngIf="((item.new_user_unsuccessful_all) - (item.new_user_unsuccessful_all_web)) > 0">
                    <div class="text-xs ml-2 mb-0">未完成：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_unsuccessful_all|number}}({{item.new_user_unsuccessful_all_p}}%)</span></div>
                    <div class="text-xs ml-4 mb-0">APP：<span class="show_it" style="pointer-events: none;color:#aaa">{{(item.new_user_unsuccessful_all - item.new_user_unsuccessful_all_web)|number}}</span></div>
                    <div class="text-xs ml-4 mb-0">Web：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.new_user_unsuccessful_all_web|number}}</span></div>
                </div>
            </div>
            <div (click)="pageobj2.page=0;fuck_view(item.time_id,3)" data-toggle="modal" data-target=".bd-example-modal-lg" class="card-text">總鑽花費數：<span class="show_it">{{item.all_diamond|number}}</span></div>
            <div>
                <div class="text-xs ml-2 mb-0">文字：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.text_diamond_all|number}}({{item.text_diamond_all_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">語音：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.voice_diamond_all|number}}({{item.voice_diamond_all_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">視訊：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.video_diamond_all|number}}({{item.video_diamond_all_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">解鎖：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.delock_diamond_all|number}}({{item.delock_diamond_all_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">禮物：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.gift_diamond_all|number}}({{item.gift_diamond_all_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">遊戲：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.game_diamond_all|number}}({{item.game_diamond_all_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">直播：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.all_live_diamond|number}}({{item.all_live_diamond_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">語音房：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.voice_room_diamond_all|number}}({{item.voice_room_diamond_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">紅包：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.chat_donate_diamond_all|number}}({{item.chat_donate_diamond_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">互動：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.interactive_diamond_male|number}}({{item.interactive_diamond_male_p}}%)</span></div>
            </div>
            <div  (click)="msgViewPeople=true; gender_type_num = 0; pageobj2.page = 0; fuck_view(item.time_id, 4)" data-toggle="modal" data-target=".bd-example-modal-lg">發送訊息(人)：
                <span class="show_it"><span class="boy">{{item.text_user_num_male|number}}</span> / <span class="girl">{{item.text_user_num_female|number}}</span></span>
            </div>
            <div *ngIf="item.msg_users_only_real_male !== undefined" class="text-xs ml-3 mb-0" style="color:#888;pointer-events:none;">
                ┗ 純真實：<span class="boy">{{item.msg_users_only_real_male|number}}</span> / <span class="girl">{{item.msg_users_only_real_female|number}}</span>
                　純群發：<span class="boy">{{item.msg_users_only_mass_male|number}}</span> / <span class="girl">{{item.msg_users_only_mass_female|number}}</span>
                　兩者皆發：<span class="boy">{{item.msg_users_both_male|number}}</span> / <span class="girl">{{item.msg_users_both_female|number}}</span>
            </div>
            <div class="card-text" style="cursor: pointer;" (click)="msgViewPeople=false; gender_type_num = 0; pageobj2.page = 0; fuck_view(item.time_id, 4)" data-toggle="modal" data-target=".bd-example-modal-lg">
                發送訊息(次)：<span class="boy">{{item.text_num_male|number}}</span> / <span class="girl">{{item.text_num_female|number}}</span>
            </div>
            <div *ngIf="item.msg_count_real_male !== undefined" class="text-xs ml-3 mb-0" style="color:#888;">
                ┗ 真實：<span class="boy">{{item.msg_count_real_male|number}}</span> / <span class="girl">{{item.msg_count_real_female|number}}</span>
                　群發：<span class="boy">{{item.msg_count_mass_male|number}}</span> / <span class="girl">{{item.msg_count_mass_female|number}}</span>
            </div>
            <div class="card-text" style="cursor: pointer;" data-toggle="modal" data-target=".bd-example-modal-lg" (click)="gender_type_num = 0;time_id = item.time_id;pageobj2.page=0;fuck_view(item.time_id,8)">
                上線人數<span class="tips">(不重複)</span>：<span class="boy">{{item.login_male_nums|number}}</span> / <span class="girl">{{item.login_female_nums|number}}</span>
            </div>
            <div class="card-text" style="cursor: pointer;" data-toggle="modal" data-target=".bd-example-modal-lg" (click)="gender_type_num = 0;time_id = item.time_id;fuck_view(item.time_id,7)">
                上線未聊天人數<span class="tips">(不重複)</span>：<span class="boy">{{item.male_count|number}}</span> / <span class="girl" >{{item.female_count|number}}</span>
            </div>
            <div  (click)="pageobj2.page = 0; fuck_view(item.time_id, 5)" data-toggle="modal" data-target=".bd-example-modal-lg"  class="card-text">簡訊：
                <span class="show_it">{{item.sms_send_num_all|number}}</span>/
                <span class="show_it">{{item.sms_confirm_num_all|number}}</span>
            </div>
            <div class="card-text" (click)="gender_type_num = 0; sort_obj_detail = {column:'',sort:'0'}; pageobj2.page = 0; fuck_view(item.time_id, 6)" data-toggle="modal" data-target=".bd-example-modal-lg">
                刪除人數： <span class="show_it">{{item.delete_num|number}}</span>
            </div>
            <div class="card-text">
                個人頁觀看回覆率：{{item.rate|number}}%
            </div>
            <div  class="card-text">群發數：
                <span >{{item.mass_msg_total|number}}</span>
            </div>
            <div>
                <div class="text-xs ml-2 mb-0">點開數：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.mass_read_num|number}}({{item.mass_read_num_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">回復數：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.mass_reply_num|number}}({{item.mass_read_num_p}}%)</span></div>
                <div class="text-xs ml-2 mb-0">儲值金額：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.mass_deposit_amount|number}}</span></div>
                <div class="text-xs ml-2 mb-0">儲值筆數：<span class="show_it" style="pointer-events: none;color:#aaa">{{item.mass_deposit_num|number}}</span></div>
            </div>
        </div>
    </div>
    <div class="card text-white bg-light third_info" *ngIf="!isTab9()">
        <div class="card-body" >
            <!-- <div class="card-text top_info_num">三竹：{{third_data?.mitake|number}}點</div> -->

            <div class="card-text top_info_num">
                <a  target="_blank"  href="{{ link }}/smsrecode/3">av8d：{{third_data?.av8d|number}}點</a>
            </div>
            <div class="card-text top_info_num">
                <a  target="_blank"  href="{{ link }}/smsrecode/2">twilio：{{third_data?.twilio}}美元</a>
            </div>
            <div class="card-text top_info_num">
                <a  target="_blank"  href="{{ link }}/smsrecode/4">mitake：{{third_data?.mitake|number}}點</a>
            </div>
            <div class="card-text top_info_num">總儲值率：{{third_data?.deposit_rate}}%</div>
            <div class="card-text top_info_num">男生客單價：{{third_data?.avg_money_depositer|number}}元</div>
            <div class="card-text top_info_num">男平均儲值：{{third_data?.avg_money_male|number}}元</div>
            <div class="card-text top_info_num">過去1小花鑽數：{{third_data?.diamond_hour_consume|number}}鑽</div>

            <div class="range-card">
                <div class="range-left">
                    <div class="range-title">沒收到訊息的目標大戶數（　儲值額大於100000元　）</div>
                    <div class="range-value range-value-with-action d-flex">
                        <div class="value-main">
                            {{ noMsgWhaleCount | number }} <span class="unit">位</span>
                        </div>
                        <button class="btn-view-list ml-auto" type="button" (click)="openNoMsgWhaleModal()" data-toggle="modal" data-target=".bd-NoMsgWhaleModal-modal-lg">
                            查看名單
                        </button>
                    </div>
                    <div class="range-sub">區間：{{ rangeStart }} ~ {{ rangeEnd }}</div>
                </div>

                <div class="range-right">
                    <div class="user-filter-tabs">
                        <button
                            class="user-filter-tab"
                            [class.active]="filterType === 'all'"
                            (click)="changeFilterType('all')">
                            全部目標
                        </button>

                        <button
                            class="user-filter-tab"
                            [class.active]="filterType === 'online'"
                            (click)="changeFilterType('online')">
                            區間有上線
                        </button>
                    </div>
                    <div class="range-controls">

                        <div class="field">
                            <label>開始日期</label>
                            <!-- <input type="date" [(ngModel)]="rangeStart" (change)="onRangeChange()"> -->
                            <input
                                type="date"
                                [(ngModel)]="rangeStart"
                                [min]="minDate"
                                [max]="maxDate"
                                (change)="onRangeChange()"
                            />
                        </div>

                        <span class="sep">～</span>

                        <div class="field">
                            <label>結束日期</label>
                            <!-- <input type="date" [(ngModel)]="rangeEnd" (change)="onRangeChange()"> -->
                            <input
                                type="date"
                                [(ngModel)]="rangeEnd"
                                [min]="minDate"
                                [max]="maxDate"
                                (change)="onRangeChange()"
                            />
                        </div>

                        <button class="btn-primary-1" type="button" (click)="applyRange()">
                            查詢
                        </button>

                        <button class="btn-ghost-1" type="button" (click)="resetRange()" [disabled]="loading">
                            重設
                        </button>
                    </div>

                    <div class="range-hint" *ngIf="!isRangeValid">
                        結束日期需大於或等於開始日期
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-table-v2  *ngIf="data.length>0 && !isTab9()" [type]="1" [tcontent]="tcontent" [data]="data" (sortdata)="handlesortdata($event)">
        <ng-template let-post #operation_dk>
            <div *ngIf="post.key == 'deposit_twd_all' || post.key == 'withdrawal_twd'">
                <p>{{post.val[post.key]}}元</p>
            </div>

            <div *ngIf="post.key == 'new_user_deposit_all'">
                <p>{{post.val[post.key]}}人</p>
            </div>

            <div *ngIf="post.key == 'regist_info'">
                <p [innerHTML]="post.val[post.key]"></p>
            </div>

        </ng-template>
    </app-table-v2>

    <!-- <r-table [data]="posts_input" ></r-table> -->




    <app-pagnation *ngIf="!isTab9()" (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>
    </div>
    <div *ngIf="now!=='2' && now!=='0' && !isTab9() && !loading" style="margin: 30px 0 0 10px;">
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="lineOptions" style="display: block;width: 70%;"></highcharts-chart>
    </div>
    <div *ngIf="now=='2'  && !loading" style="margin: 30px 0 0 10px;">
        <highcharts-chart [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions" style="display: block;width: 70%;"></highcharts-chart>
    </div>
</div>

<div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog"
    data-keyboard="false" data-backdrop="static"
    aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content" >
        <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title">{{show_time}}</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

        <!-- Modal body -->
            <div class="modal-body">
                <div *ngIf="edit_data.length>0 && action == 5">
                    <table class="table table-responsive-sm" *ngIf="edit_data.length>0">
                        <thead>
                            <tr class="table-primary" style="font-size:18px;">
                                <th style="width:5%">國家名</th>
                                <th style="width:5%">發送數</th>
                                <th style="width:5%">驗證數</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of edit_data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                                <td>{{item.c_name}}</td>
                                <td>{{item.send_num}}</td>
                                <td>{{item.get_num}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="edit_data.length == 0">無資料</div>
                </div>

                <div *ngIf="edit_data.length>0 && consume.para && (action == 7 || action == 8) && !msgDetail.open">

                    <select class="form-control" style="width: 160px;display: inline-block;margin-bottom: 10px;" [(ngModel)]="gender_type_num" (change)="pageobj2.page=0;fuck_view(time_id,action);">
                        <option *ngFor="let item of gender_type" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <!-- 合計：後端對切頁前的整份名單數 is_hidden（2026-09-16）；舊後端沒回這兩個欄位就不顯示 -->
                    <span class="modal-sum" *ngIf="consume.hidden_num !== undefined">
                        合計：隱藏 <b>{{consume.hidden_num | number}}</b> 人／未隱藏 <b>{{consume.visible_num | number}}</b> 人
                        <small>（共 {{pageobj2.total_count | number}} 人，本頁 {{edit_data.length}} 筆）</small>
                    </span>

                    <app-table-v2  *ngIf="data.length>0" [tcontent]="tcontent1" [type]="1" [data]="edit_data" (sortdata)="handlesortdetail($event)">
                        <ng-template let-post #operation_dk>
                            <div *ngIf="post.key == 'diamond'">
                                {{ post.val.diamond | number:'1.0-0' }}
                            </div>

                            <div *ngIf="post.key == 'get_text_num'">
                                <span *ngIf="!(post.val.get_text_num > 0)">0</span>
                                <a *ngIf="post.val.get_text_num > 0" href="javascript:void(0)"
                                   (click)="openMsgDetail(post.val)" title="看是誰傳的">
                                    {{ post.val.get_text_num | number:'1.0-0' }}
                                </a>
                                <span *ngIf="post.val.get_text_num > 0 && post.val.get_text_num_real != null" class="msg-real-hint">
                                    (真人 {{ post.val.get_text_num_real | number:'1.0-0' }})
                                </span>
                            </div>

                            <div *ngIf="post.key == 'voice_num'">
                                {{ (post.val.voice_num || 0) | number:'1.0-0' }}
                            </div>
                        </ng-template>
                    </app-table-v2>
                </div>

                <!-- 收到訊息數的下鑽：這段期間是誰傳訊給他 -->
                <div *ngIf="msgDetail.open">

                    <div class="msg-detail-head">
                        <button class="btn btn-sm btn-secondary" (click)="closeMsgDetail()">← 返回名單</button>
                        <span class="msg-detail-title">{{ msgDetail.user?.name }} 收到的訊息</span>
                        <span class="msg-detail-sum" *ngIf="!msgDetail.loading">
                            共 <b>{{ msgDetail.total | number:'1.0-0' }}</b> 則
                            ／真人 <b class="msg-real">{{ msgDetail.real | number:'1.0-0' }}</b>
                            ／群發 <b class="msg-mass">{{ msgDetail.mass | number:'1.0-0' }}</b>
                            ／已讀 <b>{{ msgDetail.read | number:'1.0-0' }}</b>
                        </span>
                    </div>

                    <div *ngIf="msgDetail.loading" class="msg-detail-empty">讀取中...</div>

                    <div *ngIf="!msgDetail.loading && msgDetail.rows.length == 0" class="msg-detail-empty">
                        查無資料
                    </div>

                    <table class="table table-sm msg-detail-table" *ngIf="!msgDetail.loading && msgDetail.rows.length > 0">
                        <thead>
                            <tr class="table-secondary">
                                <th style="width:22%">傳訊者</th>
                                <th style="width:8%">則數</th>
                                <th style="width:8%">真人</th>
                                <th style="width:8%">群發</th>
                                <th style="width:8%">已讀</th>
                                <th style="width:14%">最後一則</th>
                                <th>內容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of msgDetail.rows" [class.msg-row-real]="row.real_num > 0">
                                <td>
                                    <app-userandactive [post]="row"></app-userandactive>
                                </td>
                                <td>{{ row.total | number:'1.0-0' }}</td>
                                <td><b class="msg-real" *ngIf="row.real_num > 0">{{ row.real_num | number:'1.0-0' }}</b><span *ngIf="!(row.real_num > 0)">0</span></td>
                                <td><span class="msg-mass">{{ row.mass_num | number:'1.0-0' }}</span></td>
                                <td>{{ row.read_num | number:'1.0-0' }}</td>
                                <td class="msg-detail-dt">{{ row.last_dt }}</td>
                                <td class="msg-detail-content">
                                    <span *ngIf="row.last_content">{{ row.last_content }}</span>
                                    <span *ngIf="!row.last_content" class="msg-detail-nontext">［{{ row.last_type }}］</span>
                                    <span *ngIf="row.last_is_mass == 1" class="msg-mass-tag">群發</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- 明細自己的分頁(翻頁打 API)，跟外層名單的 pageobjstr2 無關；
                         條件看 total_count 而不是 loading，翻頁讀取中分頁條不閃爍 -->
                    <app-pagnation *ngIf="msgDetail.pageobj.total_count > 0"
                        (callback)="callbackMsgDetail($event)" [data]="msgDetail.pageobj"></app-pagnation>
                </div>


                <!-- 收到訊息數下鑽開著時（action=2 也有）藏掉這塊摘要，畫面只剩明細 -->
                <div *ngIf="edit_data.length>0 && consume.para && action != 5 && action != 6  && action != 7 && action != 8 && !msgDetail.open">
                    <table class="table table-responsive-sm" >
                        <thead>
                            <tr class="table-secondary" style="font-size:18px;">
                                <th style="width:5%">os</th>
                                <th style="width:5%">性別</th>
                                <th style="width:5%" *ngIf="consume.para.action==0 || consume.para.action==1">地區出入金</th>
                                <th style="width:5%" *ngIf="consume.para.action==2">地區人數</th>
                                <th style="width:5%" *ngIf="consume.para.action==3">地區花費</th>
                                <th style="width:5%" *ngIf="consume.para.action==4">{{msgViewPeople ? '對象人數' : '訊息數'}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-light" style="font-size:18px;">
                                <td>
                                    <div class="detail_info">Android：{{consume.para.os_1}}  人</div>
                                    <div class="detail_info">iOS：{{consume.para.os_2}} 人</div>
                                    <div class="detail_info">web：{{consume.para.os_3}} 人</div>
                                    <div class="detail_info" *ngIf="consume.para.os_4 != 0">其他：{{consume.para.os_4}} 人</div>
                                </td>
                                <td>
                                    <div class="detail_info">男生：{{consume.para.gender_1}} 人</div>
                                    <div class="detail_info">女生：{{consume.para.gender_2}} 人</div>
                                    <div class="detail_info">未完成註冊：{{consume.para.gender_0}} 人</div>
                                </td>
                                <td class="cname">
                                    <div *ngFor="let city of consume.para.country; let i = index" class="detail_info">
                                        {{city.name}}：<span *ngIf="consume.para.action!=2">{{city.total|number}}</span> ({{city.num|number}} 人)
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- 訊息紀錄(action=4)：與「上線未聊天/上線人員」用同一套 app-table-v2 模板，
                     欄位換成這支 API 有的 total(訊息數) / people(對象人數) / regist_dt(註冊時間)。
                     位置要在上面那塊 os/性別/地區摘要「之後」，維持原本「摘要在上、名單在下」的順序。 -->
                <div *ngIf="edit_data.length>0 && action == 4">
                    <select class="form-control" style="width: 160px;display: inline-block;margin-bottom: 10px;"
                        [(ngModel)]="gender_type_num" (change)="pageobj2.page=0;fuck_view(time_id,action);">
                        <option *ngFor="let item of gender_type" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <span class="tips" style="margin-left:8px;">
                        合計 <b>{{consume.total | number}}</b> 則 ／ <b>{{consume.people | number}}</b> 人
                        （本頁 {{edit_data.length}} 筆，共 {{pageobj2.total_count | number}} 人）。
                        預設依<b>{{msgViewPeople ? '對象人數' : '訊息數'}}</b>排序，點欄位標題可改。
                    </span>

                    <app-table-v2 [tcontent]="tcontent_msg" [type]="1" [data]="edit_data" (sortdata)="handlesortdetail($event)">
                        <ng-template let-post #operation_dk>
                            <div *ngIf="post.key == 'total'">{{ (post.val.total || 0) | number:'1.0-0' }} 則</div>
                            <div *ngIf="post.key == 'people'">{{ (post.val.people || 0) | number:'1.0-0' }} 人</div>
                            <!-- os_type 代碼同上方摘要：1 Android / 2 iOS / 3 web，其他照代碼顯示 -->
                            <div *ngIf="post.key == 'os_type'">{{ post.val.os_type == 1 ? 'Android' : (post.val.os_type == 2 ? 'iOS' : (post.val.os_type == 3 ? 'web' : (post.val.os_type ? '其他(' + post.val.os_type + ')' : '—'))) }}</div>
                        </ng-template>
                    </app-table-v2>
                </div>

                <!-- 註冊用戶(action=2)：與「上線未聊天/上線人員」同一套 app-table-v2 模板（2026-09-15），
                     位置同樣在上方 os/性別/地區摘要之後。has_deposit=區間內儲值鑽數（後端 deposit_record 彙總，0 表示沒儲值）。
                     get_text_num=區間內收到的訊息數（2026-09-16 補），點數字下鑽看是誰傳的，與 action 7/8 共用 msgDetail 那塊，
                     所以下鑽開著時這張表要藏掉。性別下拉與排序都重打 API，後端 action=2 在切頁前套用。 -->
                <div *ngIf="edit_data.length>0 && action == 2 && !msgDetail.open">
                    <select class="form-control" style="width: 160px;display: inline-block;margin-bottom: 10px;"
                        [(ngModel)]="gender_type_num" (change)="pageobj2.page=0;fuck_view(time_id,action);">
                        <option *ngFor="let item of gender_type" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <!-- 合計：與上線未聊天那張同一支 count_hidden（2026-09-16）；舊後端沒回就不顯示 -->
                    <span class="modal-sum" *ngIf="consume.hidden_num !== undefined">
                        合計：隱藏 <b>{{consume.hidden_num | number}}</b> 人／未隱藏 <b>{{consume.visible_num | number}}</b> 人
                        <small>（共 {{pageobj2.total_count | number}} 人，本頁 {{edit_data.length}} 筆）</small>
                    </span>
                    <div class="tips" style="margin:2px 0 6px;">
                        預設依<b>註冊時間</b>新到舊，點欄位標題可改。「收到訊息數」是這段期間收到的訊息（括號內為真人私訊，其餘是群發），點數字看是誰傳的。
                    </div>

                    <app-table-v2 [tcontent]="tcontent_reg" [type]="1" [data]="edit_data" (sortdata)="handlesortdetail($event)">
                        <ng-template let-post #operation_dk>
                            <div *ngIf="post.key == 'diamond'">{{ (post.val.diamond || 0) | number:'1.0-0' }}</div>
                            <div *ngIf="post.key == 'has_deposit'">
                                <span *ngIf="!(post.val.has_deposit > 0)" style="color:#aaa">—</span>
                                <span *ngIf="post.val.has_deposit > 0" style="color:#1a7f37">{{ post.val.has_deposit | number:'1.0-0' }} 鑽</span>
                            </div>
                            <div *ngIf="post.key == 'get_text_num'">
                                <span *ngIf="!(post.val.get_text_num > 0)">0</span>
                                <a *ngIf="post.val.get_text_num > 0" href="javascript:void(0)"
                                   (click)="openMsgDetail(post.val)" title="看是誰傳的">
                                    {{ post.val.get_text_num | number:'1.0-0' }}
                                </a>
                                <span *ngIf="post.val.get_text_num > 0 && post.val.get_text_num_real != null" class="msg-real-hint">
                                    (真人 {{ post.val.get_text_num_real | number:'1.0-0' }})
                                </span>
                            </div>
                            <div *ngIf="post.key == 'os_type'">{{ post.val.os_type == 1 ? 'Android' : (post.val.os_type == 2 ? 'iOS' : (post.val.os_type == 3 ? 'web' : (post.val.os_type ? '其他(' + post.val.os_type + ')' : '—'))) }}</div>
                        </ng-template>
                    </app-table-v2>
                </div>

                <!-- 刪除人員(action=6)：與「上線未聊天/上線人員」同一套 app-table-v2 模板（2026-09-16）。
                     沒有 os/性別/地區摘要那塊（後端 action 6 本來就不算），直接是 性別下拉 + 合計 + 表。 -->
                <div *ngIf="edit_data.length>0 && action == 6 && !msgDetail.open">
                    <select class="form-control" style="width: 160px;display: inline-block;margin-bottom: 10px;"
                        [(ngModel)]="gender_type_num" (change)="pageobj2.page=0;fuck_view(time_id,action);">
                        <option *ngFor="let item of gender_type" [ngValue]="item.id">{{item.name}}</option>
                    </select>
                    <span class="modal-sum" *ngIf="consume.hidden_num !== undefined">
                        合計：隱藏 <b>{{consume.hidden_num | number}}</b> 人／未隱藏 <b>{{consume.visible_num | number}}</b> 人
                        <small>（共 {{pageobj2.total_count | number}} 人，本頁 {{edit_data.length}} 筆）</small>
                    </span>
                    <div class="tips" style="margin:2px 0 6px;">
                        刪除時間＝帳號被刪的時間。「收到訊息數」「語音通訊筆數」是這段期間收到的訊息（括號內為真人私訊）與被打進來的通話，點數字看是誰傳的。
                    </div>

                    <app-table-v2 [tcontent]="tcontent_del" [type]="1" [data]="edit_data" (sortdata)="handlesortdetail($event)">
                        <ng-template let-post #operation_dk>
                            <div *ngIf="post.key == 'diamond'">{{ (post.val.diamond || 0) | number:'1.0-0' }}</div>
                            <div *ngIf="post.key == 'get_text_num'">
                                <span *ngIf="!(post.val.get_text_num > 0)">0</span>
                                <a *ngIf="post.val.get_text_num > 0" href="javascript:void(0)"
                                   (click)="openMsgDetail(post.val)" title="看是誰傳的">
                                    {{ post.val.get_text_num | number:'1.0-0' }}
                                </a>
                                <span *ngIf="post.val.get_text_num > 0 && post.val.get_text_num_real != null" class="msg-real-hint">
                                    (真人 {{ post.val.get_text_num_real | number:'1.0-0' }})
                                </span>
                            </div>
                            <div *ngIf="post.key == 'voice_num'">{{ (post.val.voice_num || 0) | number:'1.0-0' }}</div>
                            <div *ngIf="post.key == 'os_type'">{{ post.val.os_type == 1 ? 'Android' : (post.val.os_type == 2 ? 'iOS' : (post.val.os_type == 3 ? 'web' : (post.val.os_type ? '其他(' + post.val.os_type + ')' : '—'))) }}</div>
                        </ng-template>
                    </app-table-v2>
                </div>

                <!-- action=2/4/6 已改用上方的 app-table-v2（與上線未聊天同一套模板），這張舊表只服務 action 0/1/3 -->
                <table class="table table-responsive-sm" *ngIf="edit_data.length>0 && action !=2 && action !=4 && action !=5 && action != 6 && action != 7 && action != 8">
                    <thead>
                        <tr class="table-primary" style="font-size:18px;">
                            <th style="width:5%">姓名</th>
                            <th style="width:5%">大頭貼</th>
                            <th style="width:5%">註冊日</th>
                            <th style="width:5%">os</th>
                            <th style="width:5%" *ngIf="action == 6">最後修改時間</th>
                            <th style="width:5%" *ngIf="action!=3 && action!=2 && action!=4  && action!=6">出入/金</th>
                            <th style="width:5%" *ngIf="action == 4">{{msgViewPeople ? '對象人數' : '訊息數'}}</th>
                            <th style="width:5%" *ngIf="action==3">訊息</th>
                            <th style="width:5%" *ngIf="action==3">語音</th>
                            <th style="width:5%" *ngIf="action==3">視訊</th>
                            <th style="width:5%" *ngIf="action==3">解鎖</th>
                            <th style="width:5%" *ngIf="action==3">禮物</th>
                            <th style="width:5%" *ngIf="action==3">遊戲</th>
                            <th style="width:5%" *ngIf="action==3">直播</th>
                            <th style="width:5%" *ngIf="action==3">約會</th>
                            <th style="width:5%" *ngIf="action==3">語音房</th>
                            <th style="width:5%" *ngIf="action==3">打賞</th>
                            <th style="width:5%" *ngIf="action==3">總花費</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of edit_data; let i = index" class="{(index % 2 ==0)?'table-secondary':'table-light'}">
                            <td>
                                <span *ngIf="item.name && item.name.length>0">
                                    <app-userandactive  [post]="item"></app-userandactive>
                                    <div *ngIf="action==2 && item.has_deposit && item.has_deposit>0">
                                        <div class="tips">({{item.has_deposit|number}}鑽)</div>
                                    </div>
                                </span>
                                <span *ngIf="item.name.length==0" >未填寫</span>
                            </td>
                            <td>
                                <img loading="lazy" *ngIf="item.profile_pic.length > 0" style="width: 50px" src="{{item.profile_pic}}">
                                <span *ngIf="item.profile_pic.length == 0" >未填寫</span>
                            </td>
                            <td *ngIf="action!=6">{{item.regist_dt}}</td>
                            <td *ngIf="action==6">{{item.create_dt}}</td>
                            <td>{{item.os_type==1?'Android':'iOS'}}</td>
                            <td *ngIf="action==6">{{item.update_dt}}</td>
                            <td *ngIf="action!=3 && action!=2 && action!=4 && action!=6">{{item.all_money|number}}</td>
                            <td *ngIf="action==3">{{item.text|number}}鑽</td>
                            <td *ngIf="action==3">{{item.voice|number}}鑽</td>
                            <td *ngIf="action==3">{{item.video|number}}鑽</td>
                            <td *ngIf="action==3">{{item.delock|number}}鑽</td>
                            <td *ngIf="action==3">{{item.gift|number}}鑽</td>
                            <td *ngIf="action==3">{{item.game|number}}鑽</td>
                            <td *ngIf="action==3">{{item.live|number}}鑽</td>
                            <td *ngIf="action==3">{{item.dating|number}}鑽</td>
                            <td *ngIf="action==3">{{item.voice_room|number}}鑽</td>
                            <td *ngIf="action==3">{{item.chat_donate|number}}鑽</td>
                            <td *ngIf="action==3">{{item.total|number}}鑽</td>
                            <td *ngIf="action==4">{{(msgViewPeople ? item.people : item.total)|number}}{{msgViewPeople?'人':'則'}}</td>
                        </tr>
                        <tr *ngIf="action!=2 && action!=6">
                            <td>總和</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td *ngIf="action!=3">{{((action==4 && msgViewPeople) ? consume.people : consume.total)|number}}</td>
                            <td *ngIf="action==3">{{consume.text|number}}</td>
                            <td *ngIf="action==3">{{consume.voice|number}}</td>
                            <td *ngIf="action==3">{{consume.video|number}}</td>
                            <td *ngIf="action==3">{{consume.delock|number}}</td>
                            <td *ngIf="action==3">{{consume.gift|number}}</td>
                            <td *ngIf="action==3">{{consume.game|number}}</td>
                            <td *ngIf="action==3">{{consume.live|number}}</td>
                            <td *ngIf="action==3">{{consume.dating|number}}</td>
                            <td *ngIf="action==3">{{consume.voice_room|number}}</td>
                            <td *ngIf="action==3">{{consume.chat_donate|number}}</td>
                            <td *ngIf="action==3">{{consume.total|number}}</td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="edit_data.length==0">無資料</div>
            </div>
            <!-- 這是外層名單(edit_data)的分頁；下鑽明細不分頁，開著時要藏掉 -->
            <app-pagnation *ngIf="!msgDetail.open" (callback)="callback2($event)" [data]="pageobjstr2"></app-pagnation>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button"   class="btn btn-primary" data-dismiss="modal">確認</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade bd-NoMsgWhaleModal-modal-lg" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" >
            <!-- Modal Header -->
            <div class="modal-header">
                <h5 class="modal-title">沒收到訊息的目標大戶名單</h5>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div style="display: flex; justify-content: center; flex-wrap: wrap; align-items: flex-end;">
                <div class="data-hint mt-2">
                    <p>📌 資料統計截至昨日，可能存在時間延遲</p>
                </div>
                <div class="push-actions">
                    <button class="push-action-btn push-action-main text-nowrap mx-1" (click)="pushMsg(1)">
                        推播
                    </button>

                    <button class="push-action-btn push-action-sub text-nowrap mx-1" (click)="pushMsg(2)">
                        tag推播
                    </button>
                </div>
            </div>
            <!-- Modal body -->
            <div class="modal-body">

                <div class="noMsgWhal-searchBar">
                    <input
                        class="noMsgWhal-input"
                        type="text"
                        placeholder="搜尋用戶名稱 / UID"
                        [(ngModel)]="noMsgWhalKeywordTmp"
                        (keydown.enter)="onNoMsgWhalSearch()"
                    />

                    <button
                        class="noMsgWhal-searchBtn"
                        type="button"
                        (click)="onNoMsgWhalSearch()"
                    >
                        搜尋
                    </button>
                </div>
                <div *ngIf="noMsgWhaleList.length==0" style="text-align: center;">無資料</div>
                <div style="width: 100%; overflow-x: auto; display: flex; justify-content: center;">
                    <app-table-v2  *ngIf="data.length>0" [type]="1" [tcontent]="tcontent2" [data]="noMsgWhaleList" (sortdata)="handlesortNoMsgdata($event)">
                    <ng-template let-post #operation_dk>
                        <div *ngIf="post.key == 'deposit_twd'">
                            <p>{{post.val.deposit_twd | number}}元</p>
                        </div>
                    </ng-template>
                </app-table-v2>
                </div>
            </div>
            <app-pagnation (callback)="callback3($event)" [data]="pageobjstr3"></app-pagnation>
            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button"   class="btn btn-primary" data-dismiss="modal">關閉</button>
            </div>
        </div>
    </div>
</div>
<app-spinner [loading]="loading"></app-spinner>
